'use strict';

var _swiper = require('swiper');

var _swiper2 = _interopRequireDefault(_swiper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = function init() {
  var sliders = document.querySelectorAll('.image-slider-container');

  var doSlider = function doSlider(slider) {
    var swiper = new _swiper2.default(slider, {
      modules: [_swiper.Navigation, _swiper.Pagination],
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });

    swiper.on('slideChange', function (el) {
      var descriptions = slider.querySelectorAll('.image-slider-description');

      if (descriptions && descriptions.length > 0) {
        descriptions.forEach(function (desc) {
          desc.classList.remove('active');
        });

        descriptions['' + el.realIndex].classList.add('active');
        // console.log(selectedDesc);
        console.log(el);
      }
    });
  };

  if (sliders && sliders.length > 0) {
    sliders.forEach(function (slider) {
      doSlider(slider);
    });
  }

  var propertySliders = document.querySelectorAll('.property-carousel-container');

  var doPropertySlider = function doPropertySlider(slider) {
    new _swiper2.default(slider, {
      slidesPerView: 'auto',
      spaceBetween: 16
    });
  };

  if (propertySliders && propertySliders.length > 0) {
    propertySliders.forEach(function (slider) {
      doPropertySlider(slider);
    });
  }

  var landingNotificationBar = document.querySelector('.landing-notification-bar');

  var doLandingNotificationBar = function doLandingNotificationBar(slider) {
    new _swiper2.default(slider, {
      modules: [_swiper.Autoplay],
      grabCursor: false,
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 0,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false
      },
      freeMode: true,
      speed: 3000
    });
  };

  if (landingNotificationBar) {
    doLandingNotificationBar(landingNotificationBar);
  }

  var landCardsSliders = document.querySelectorAll('.land-cards-carousel');

  var doLandCardsSlider = function doLandCardsSlider(slider) {
    var swiper = new _swiper2.default(slider, {
      modules: [_swiper.Navigation, _swiper.Pagination],
      slidesPerView: 1,
      spaceBetween: 20,
      breakpoints: {
        560: {
          slidesPerView: 2
        },
        768: {
          slidesPerView: 3
        },
        1080: {
          slidesPerView: 4
        }
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  };

  if (landCardsSliders && landCardsSliders.length > 0) {
    landCardsSliders.forEach(function (slider) {
      doLandCardsSlider(slider);
    });
  }
};

document.addEventListener('DOMContentLoaded', function () {
  return init();
});


// WEBPACK FOOTER //
// ./scripts/sliders.js